"use client"

import { useState } from "react"
import { Menu, X } from "lucide-react"

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#F5E6D3]/95 backdrop-blur-sm border-b border-[#E67E22]/20">
      <div className="max-w-7xl mx-auto px-8 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-[#E67E22] rounded-full flex items-center justify-center flex-shrink-0">
              <span className="text-white font-bold text-lg">GD</span>
            </div>
            <div>
              <h1 className="font-bold text-xl text-black">GRON'S</h1>
              <p className="text-sm text-[#E67E22] font-semibold">DODGEBALL</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <a href="#widgets" className="text-black hover:text-[#E67E22] transition-colors font-medium">
              Start
            </a>
            <a href="#about" className="text-black hover:text-[#E67E22] transition-colors font-medium">
              About
            </a>
            <a href="#memberships" className="text-black hover:text-[#E67E22] transition-colors font-medium">
              Memberships
            </a>
            <a href="#events" className="text-black hover:text-[#E67E22] transition-colors font-medium">
              Events
            </a>
            <a href="#contact" className="text-black hover:text-[#E67E22] transition-colors font-medium">
              Contact
            </a>
          </nav>

          {/* Help Button & Mobile Menu */}
          <div className="flex items-center gap-4">
            <button className="hidden md:block bg-[#E67E22] text-white px-6 py-2 rounded-full hover:bg-[#D35400] transition-colors font-medium">
              Help
            </button>
            <button className="md:hidden p-2" onClick={() => setIsMenuOpen(!isMenuOpen)}>
              {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 border-t border-[#E67E22]/20 pt-4">
            <div className="flex flex-col gap-4">
              <a href="#widgets" className="text-black hover:text-[#E67E22] transition-colors font-medium">
                Start
              </a>
              <a href="#about" className="text-black hover:text-[#E67E22] transition-colors font-medium">
                About
              </a>
              <a href="#memberships" className="text-black hover:text-[#E67E22] transition-colors font-medium">
                Memberships
              </a>
              <a href="#events" className="text-black hover:text-[#E67E22] transition-colors font-medium">
                Events
              </a>
              <a href="#contact" className="text-black hover:text-[#E67E22] transition-colors font-medium">
                Contact
              </a>
              <button className="bg-[#E67E22] text-white px-6 py-2 rounded-full hover:bg-[#D35400] transition-colors font-medium w-fit">
                Help
              </button>
            </div>
          </nav>
        )}
      </div>
    </header>
  )
}
